module.exports = __webpack_public_path__ + "img/registration_at_schema.ab868c18.svg";